// extracted by mini-css-extract-plugin
module.exports = {"chartv2":"Chartv2_chartv2__2PqUw"};